import { render, staticRenderFns } from "./MintalMesPrdFieldOpcConfigList.vue?vue&type=template&id=25442fc9&"
import script from "./MintalMesPrdFieldOpcConfigList.vue?vue&type=script&lang=js&"
export * from "./MintalMesPrdFieldOpcConfigList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports